export default {
  messages: {
    maxFileSize: 'The file size must be equal to or less than {1} Mb.',
    totalFileSize: 'The file size must be equal to or less than 8 Mb.',
    fileType: 'Invalid file format. The file must be {1}.',
    maxAmount: 'The amount {0} exceeds maximum allowable. (99.999.999,00).',
    table: 'The table {0} must contain at least 1 element.',
    detailsTable: 'To continue, you must add at least one detail line.',
    taxesTable: 'The table of taxes must contain at least 1 element',
    deliveryNotesTable: 'The table of delivery notes must contain at least 1 element',
    taxesTypes: 'The taxes introduced cant be the same type',
    cifNotProvider: 'The client and provider documents can\'t be the same',
    dateFromSubscription: `It's not allowed filter before three months ago in a free subscription`,
    dateMaxRange: 'The search can only cover a maximum period of 3 months',
    clientEmailRequired: `The Client's Email field is required.`,
    clientEmailInvalid: `The Client's Email is not valid.`,
    notSupportedNumber: 'The number field can not match the invoice ID.',
    validFileName: 'The file name contains unsupported characters. Only letters, numbers, spaces, dots, hyphens, underscores, and parentheses are allowed.'
  }
}
